import service from "@/utils/request";

/**
 * إرجاع جميع التعليقات
 */
export const getAllComments = async (page = 1) => {
    try {
        const response = await service.get(`/comments?page=${page}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch Comments:", e);
    }
};

/**
 * إرجاع تعليق معين
 */
export const getCommentById = async (id) => {
    try {
        const response = await service.get(`/comments/${id}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch Comment:", e);
    }
};

/**
 * إضافة تعليق جديد
 */
export const addComment = async (comment) => {
    try {
        const response = await service.post('/comments', comment);
        return response;
    } catch (e) {
        console.error("Failed to add Comment:", e);
    }
};

/**
 * تحديث بيانات تعليق
 */
export const updateComment = async (id, comment) => {
    try {
        const response = await service.put(`/comments/${id}`, comment);
        return response;
    } catch (e) {
        console.error("Failed to update Comment:", e);
    }
};

/**
 * حذف تعليق
 */
export const deleteComment = async (id) => {
    try {
        const response = await service.delete(`/comments/${id}`);
        return response;
    } catch (e) {
        console.error("Failed to delete Comment:", e);
    }
};

export const getCommentsByLead = async (leadId) => {
    try {
        const response = await service.get(`/comments/lead/${leadId}`);
        return response;
    } catch (e) {
        console.error("Failed to fetch comments for lead:", e);
    }
};
